import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal
} from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { PackageResponse } from "src/domain/client";
import { FormService } from "src/app/services/form.service";
import { SectionTogglerComponent } from "../../layout/section-toggler/section-toggler.component";
import { AdditionalServicesComponent } from "../../layout/additional-services/additional-services.component";

@Component({
  selector: "app-specs-additional-services-section",
  templateUrl: "./specs-additional-services-section.component.html",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SectionTogglerComponent,
    ReactiveFormsModule,
    AdditionalServicesComponent,
    TranslateModule
  ]
})
export class SpecsAdditionalServicesSectionComponent {
  additionalPackages = input.required<PackageResponse[]>();

  toggle = signal(false);

  constructor(public formService: FormService) {}

  get form() {
    return this.formService.chooseSpecificationsForm.controls
      .additionalPackagesForm;
  }
}
